import PropTypes from "prop-types";
import style from "./styles";

const PremierUnavailableMessage = ({
  premierAvailable,
  premierDeliveryUnavailableText,
}) =>
  !premierAvailable ? (
    <div
      className={style.PremierUnavailableMessage}
      style={{ backgroundColor: premierDeliveryUnavailableText.fillColor }}
    >
      <p>
        <span
          className={style.PremierUnavailableMessageInfoIcon}
          aria-hidden="true"
        >
          i
        </span>
        <span className={style.PremierUnavailableMessageText}>
          {premierDeliveryUnavailableText.text}
        </span>
      </p>
    </div>
  ) : null;

PremierUnavailableMessage.propTypes = {
  premierAvailable: PropTypes.bool.isRequired,
  premierDeliveryUnavailableText: PropTypes.object.isRequired,
};

export default PremierUnavailableMessage;
